/*
  We don't really like this HAL style of API, but we need to continue
  supporting it for backwards compatibility. We consider this API form legacy,
  and should not be used for new development.
*/
export const getEmbed = <T>(resource: any, rel: string, def: any = {}): T[] => {
  const embed = resource && resource._embedded && resource._embedded[rel];
  return embed || def;
};
